var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Expenses","doc":_vm.doc},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('IconBtn',{attrs:{"icon":"mdi-plus","title":"Add"},on:{"click":_vm.create}})]},proxy:true}])},[_c('div',{staticClass:"d-flex flex-row justify-end mb-3"},[_c('MonthSelector',{on:{"select":_vm.load}})],1),_c('Table'),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }